<template>
 <div>
    <b-form-group>
      <label for="blocked_rules">Szabályok blokkolása</label>
      <b-input-group>
        <b-form-select
          v-model="selectedRule"
          :options="rules"
        />
        <b-input-group-append class="ml-2">
          <b-button-group>
            <b-button
              variant="danger"
              size="sm"
              :disabled="selectedRule === null"
              @click="add(selectedRule)"
            >
              <i class="fas fa-lock" />
              <span>Blokkolás</span>
            </b-button>
          </b-button-group>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <table class="table table-light bold-header">
      <thead>
        <tr>
          <th class="text-center" colspan="2">Blokkolt szabály</th>
          <th class="text-center">Blokkolás ideje</th>
          <th></th>
        </tr>
      </thead>
      <tr
        v-for="(rule, index) in value"
        :key="`r${index}`"
      >
        <td>
          {{ rule.id }}.
        </td>
        <td>
          {{ nameFor(rule.id).text }}
          <div v-if="!$u.is(nameFor(rule.id).code, undefined)">
            <code>{{ nameFor(rule.id).code }}</code>
          </div>
        </td>
        <td class="text-center">
          <span v-if="!$u.is(rule.blocked_at, undefined)">{{ displayFormatDateTime(rule.blocked_at) }}</span>
          <span v-if="$u.is(rule.blocked_at, undefined)" class="badge badge-success">Új blokkolás</span>
        </td>
        <td class="text-right">
          <b-button
            variant="warning"
            size="sm"
            @click="remove(rule.id)"
          >
            <i class="fas fa-lock-open" />
            <span>Blokkolás feloldása</span>
          </b-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import rules from './_rules'
import { displayFormatDateTime } from '../../utils/Date'

export default {
  props: {
    value: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },
  data() {
    return {
      selectedRule: null,
    }
  },
  computed: {
    rules() {
      return _.map(rules, rule => ({
        ...rule,
        disabled: _.findIndex(this.value, current => current.id === rule.value) !== -1
      }))
    }
  },
  methods: {
    displayFormatDateTime,
    remove(id) {
      this.$emit('remove-rule', id)
    },
    add(id) {
      this.$emit('add-rule', id)
      this.selectedRule = null
    },
    nameFor(id) {
      var element = _.find(rules, rule => rule.value === id)
      if(typeof element !== 'undefined') {
        return element
      } else {
        return {
          text: 'Ismeretlen szabály'
        }
      }
    }
  }
}
</script>